import { LabelHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = ({ className, htmlFor, ...rest }: Props) => {
  return (
    <label
      {...rest}
      htmlFor={htmlFor}
      className={twMerge('block mb-2 text-sm font-medium text-gray-900 dark:text-white', className)}
    />
  );
};
